exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@use \"sass:math\";@use \"sass:color\";._3lYWHKtmuhIss9TiwRhcCR_0{position:fixed;z-index:calc(var(--g--layer--z-index--lv1) + 20);bottom:0;left:0;box-shadow:none;width:100vw;height:var(--g--full-height);background:rgba(0,0,0,.8)}._3lYWHKtmuhIss9TiwRhcCR_0 ._1huGUcTKoVc7gkeZcv0Y1m_0{box-shadow:none;position:absolute;bottom:0;width:100%}", ""]);

// exports
exports.locals = {
	"drawer-component": "_3lYWHKtmuhIss9TiwRhcCR_0",
	"inner-box": "_1huGUcTKoVc7gkeZcv0Y1m_0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c7d363fc","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compontents/newHome/Drawer.vue
// module id = HdSu
// module chunks = 1